import { Box, MenuItem, Pagination, Select, Typography } from '@mui/material';
import type { SelectChangeEvent } from '@mui/material';

export const CANVASSING_SESSION_DETAIL_ROWS_PER_PAGE_OPTIONS = [12, 25, 50] as const;

export type CanvassingSessionDetailPaginationProps = {
  label: string;
  total: number;
  page: number;
  rowsPerPage: number;
  disabled: boolean;
  onPageChange: (page: number) => void;
  onRowsPerPageChange: (rowsPerPage: number) => void;
};

export const CanvassingSessionDetailPagination = ({
  label,
  total,
  page,
  rowsPerPage,
  disabled,
  onPageChange,
  onRowsPerPageChange,
}: CanvassingSessionDetailPaginationProps) => {
  const pageCount = Math.max(1, Math.ceil(total / rowsPerPage));

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: 1,
        minHeight: 52,
        px: 2,
        py: 0.5,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography variant="caption" color="text.secondary">
          Rows per page:
        </Typography>
        <Select
          variant="standard"
          disableUnderline
          size="small"
          value={rowsPerPage}
          disabled={disabled}
          onChange={(event: SelectChangeEvent<number>) => onRowsPerPageChange(Number(event.target.value))}
          inputProps={{ 'aria-label': `${label} rows per page` }}
        >
          {CANVASSING_SESSION_DETAIL_ROWS_PER_PAGE_OPTIONS.map(option => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </Select>
      </Box>
      <Pagination
        count={pageCount}
        page={page + 1}
        disabled={disabled}
        onChange={(_event, nextPage) => onPageChange(nextPage - 1)}
        showFirstButton
        showLastButton
        shape="rounded"
        size="small"
        aria-label={`${label} pagination`}
      />
    </Box>
  );
};
